import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IDotDongTui } from "../../model/respone/tct/IDotDongTui";
import { apiClient } from "../apiClient";

export const DOT_DONG_TUI_API = "dot-dong-tui";
export const dotDongTuiApi = {
  SelectAll: () => apiClient.get(`${DOT_DONG_TUI_API}`),
  SelectByNamHoc: (nam_hoc: string) => apiClient.get(`${DOT_DONG_TUI_API}?nam_hoc=${nam_hoc}`),
  Insert: (payload: IDotDongTui) => apiClient.post(`${DOT_DONG_TUI_API}`, payload),
  Update: (payload: IDotDongTui) => apiClient.put(`${DOT_DONG_TUI_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${DOT_DONG_TUI_API}/${id}`),
  Deletes: (id: IIdsRequest) => apiClient.put(`${DOT_DONG_TUI_API}/deletes`, id),
};
